module.exports = __webpack_public_path__ + "static/media/black-sphere-128px.fed81e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/black-sphere-128px.png
// module id = 80
// module chunks = 0